export default "__VITE_PUBLIC_ASSET__85231786__"